/* Milagron · Daha fazla ürün göster (02.11.2026)
   Koleksiyon ve arama sayfalarında sayfa numaraları yerine ürünleri aynı sayfaya ekler. */
(function () {
  if (window.__mgLoadMore) return; window.__mgLoadMore = 1;
  var AUTO_MAX = 3;            // aşağı kaydırınca kendiliğinden kaç grup gelsin
  var autoCount = 0, busy = false, io = null;
  var KEY = 'mgLm:' + location.pathname + location.search.replace(/([?&])page=\d+&?/, '$1').replace(/[?&]$/, '');

  function grid(doc) { return (doc || document).querySelector('.product-grid--coll'); }
  function box() { return document.querySelector('[data-mg-lm]'); }
  function nextLink() { return document.querySelector('[data-mg-lm-next]'); }

  function load(link) {
    if (busy || !link) return Promise.resolve(false);
    busy = true; link.classList.add('is-loading');
    var url = link.getAttribute('href');
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var g = grid(), ng = grid(doc);
      if (!g || !ng) { location.href = url; return false; }
      var frag = document.createDocumentFragment();
      Array.prototype.slice.call(ng.children).forEach(function (el) { frag.appendChild(document.importNode(el, true)); });
      g.appendChild(frag);
      var cur = box(), nb = doc.querySelector('[data-mg-lm]');
      if (cur && nb) {
        cur.querySelector('[data-mg-lm-shown]').textContent = (+nb.getAttribute('data-shown')).toLocaleString('tr-TR');
        cur.setAttribute('data-shown', nb.getAttribute('data-shown'));
        cur.setAttribute('data-page', nb.getAttribute('data-page'));
        var bar = cur.querySelector('[data-mg-lm-bar]'), nbar = nb.querySelector('[data-mg-lm-bar]');
        if (bar && nbar) bar.style.width = nbar.style.width;
        var nn = nb.querySelector('[data-mg-lm-next]');
        if (nn) link.setAttribute('href', nn.getAttribute('href')); else link.remove();
      }
      // arama motoru için gizli sayfa linklerini de güncelle
      var pages = document.querySelector('.mg-lm-pages'), np = doc.querySelector('.mg-lm-pages');
      if (pages && np) pages.innerHTML = np.innerHTML;
      document.dispatchEvent(new CustomEvent('mg:products-appended'));
      save();
      return true;
    }).catch(function () { location.href = url; return false; })
      .then(function (ok) { busy = false; link.classList.remove('is-loading'); watch(); return ok; });
  }

  function save() {
    var b = box(); if (!b) return;
    try { sessionStorage.setItem(KEY, JSON.stringify({ page: +b.getAttribute('data-page'), y: window.scrollY, t: Date.now() })); } catch (e) {}
  }

  function watch() {
    if (io) io.disconnect();
    var l = nextLink(); if (!l || autoCount >= AUTO_MAX || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; }) && !busy && autoCount < AUTO_MAX) { autoCount++; load(nextLink()); }
    }, { rootMargin: '0px 0px 900px 0px' });
    io.observe(l);
  }

  document.addEventListener('click', function (e) {
    var l = e.target.closest && e.target.closest('[data-mg-lm-next]');
    if (!l) return;
    e.preventDefault(); autoCount = AUTO_MAX; load(l);
  });

  // Ürüne girip geri gelince: aynı sayıda ürünü yükle, kaldığı yere kaydır
  function restore() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!nav || nav.type !== 'back_forward') return;
    var s; try { s = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
    var b = box(); if (!s || !b || Date.now() - s.t > 30 * 60 * 1000) return;
    var target = s.page, start = +b.getAttribute('data-page');
    if (!(target > start)) { if (s.y) window.scrollTo(0, s.y); return; }
    autoCount = AUTO_MAX;
    (function step() {
      var b2 = box(), l = nextLink();
      if (l && b2 && +b2.getAttribute('data-page') < target) load(l).then(function (ok) { if (ok) step(); else window.scrollTo(0, s.y); });
      else window.scrollTo(0, s.y);
    })();
  }

  window.addEventListener('pagehide', save);
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.product-grid--coll a')) save(); }, true);

  // Filtre/sıralama değişince sayaç kutusu yeniden çizilir: otomatik yüklemeyi baştan başlat
  var lastBox = null;
  if ('MutationObserver' in window) {
    var root = document.querySelector('filter-container') || document.body, t;
    new MutationObserver(function () {
      clearTimeout(t); t = setTimeout(function () {
        var b = box(); if (b && b !== lastBox) { lastBox = b; if (!busy) { autoCount = 0; watch(); } }
      }, 300);
    }).observe(root, { childList: true, subtree: true });
  }

  function init() { lastBox = box(); watch(); restore(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
